import _ from 'lodash';

export default function (state, action) {
    if (!state) {
        state = {
            loaded: false,
            fetchTime: '',
            questions: [],
        };
    }

    switch (action.type) {
        case 'ENRICHMENT_DATA_LOADED':
            state = Object.assign({}, state, {
                loaded: true,
                fetchTime: action.fetchTime,
                questions: _(action.questions)
                    .map((question, i) => {
                        return Object.assign(
                            {
                                number: i,
                            },
                            question
                        );
                    })
                    .value(),
            });
            break;
        case 'ENRICHMENT_ANSWER_UPDATE':
            state = Object.assign({}, state, {
                questions: _(state.questions)
                    .map(q => {
                        if (q.id == action.questionData.id) {
                            return Object.assign({}, q, action.questionData);
                        }
                        return q;
                    })
                    .value(),
            });
    }

    return state;
}
